import { Tabs } from "devextreme-react";
import { useState } from "react";
import ConfigureMappingData from "../../common/ConfigureMappingData";
import ConfigurePeriod from "./ConfigurePeriod";
import ConfigureHoliday from "./ConfigureHoliday";

const Configuration = () => {
  const [configType, setConfigType] = useState("priority");
  const [tabDataSource, setTabDataSource] = useState([
    { text: "프로젝트 Priority", type: "priority" },
    { text: "Issues", type: "issues" },
    { text: "수정 가능 기간", type: "editPeriod" },
    // { text: "공휴일", type: "holiday" },
  ]);

  const handleClickTab = (e) => {
    setConfigType(e.itemData.type);
  };

  const renderTabItem = (e) => {
    return (
      <div
        style={{
          fontSize: "16px",
          fontWeight: "bold",
          color: "black",
          textTransform: "none",
        }}
      >
        {e.text}
      </div>
    );
  };

  return (
    <>
      <Tabs
        dataSource={tabDataSource}
        defaultSelectedIndex={0}
        height={40}
        itemRender={renderTabItem}
        onItemClick={handleClickTab}
        width={750}
      />
      {configType === "priority" && (
        <>
          <div style={{ margin: "16px 0px" }}>
            프로젝트의 중요도 레벨을 설정합니다.
          </div>
          <ConfigureMappingData
            cat={"10"}
            colorEnabled={true}
            configColumnData={{
              alignment: "center",
              caption: "Level",
              dataField: "name",
              isNumber: false,
              width: 150,
            }}
            name="Priority"
            sortOrderEnabled={false}
            sumFieldEnabled={false}
            issRelEnabled={true}
          />
        </>
      )}
      {configType === "issues" && (
        <>
          <div style={{ margin: "16px 0px" }}>
            Issue의 Status, Grade, Type에 대해 설정합니다.
          </div>
          <ConfigureMappingData
            cat={"12"}
            colorEnabled={false}
            configColumnData={{
              alignment: "center",
              caption: "Status",
              dataField: "name",
              isNumber: false,
              width: 150,
            }}
            name="Issue Status"
            sortOrderEnabled={true}
            sumFieldEnabled={true}
            issRelEnabled={false}
          />
          <div style={{ height: "16px" }} />
          <ConfigureMappingData
            cat={"12"}
            colorEnabled={true}
            configColumnData={{
              alignment: "center",
              caption: "Grade",
              dataField: "name",
              isNumber: true,
              sortOrder: "desc",
              width: 150,
            }}
            name="Issue Grade"
            sortOrderEnabled={false}
            sumFieldEnabled={false}
            issRelEnabled={false}
          />
          <div style={{ height: "16px" }} />
          <ConfigureMappingData
            cat={"12"}
            colorEnabled={false}
            configColumnData={{
              alignment: "center",
              caption: "Type",
              dataField: "name",
              isNumber: false,
              width: 150,
            }}
            name="Issue Type"
            sortOrderEnabled={false}
            sumFieldEnabled={false}
            issRelEnabled={false}
          />
        </>
      )}
      {configType === "editPeriod" && (
        <>
          <div style={{ height: "16px" }} />
          프로젝트별 Timeline, Enrollment Status, Study Status를 입력 및 수정할
          수 있는 기간을 설정합니다.
          <ConfigurePeriod item={"01"} />
        </>
      )}
      {configType === "holiday" && (
        <>
          <div style={{ margin: "16px 0px" }}>
            회사의 휴일 일정을 설정합니다. 휴일은 근무일 계산에서 자동으로
            차감됩니다.
          </div>
          <ConfigureHoliday item={"02"} />
        </>
      )}
    </>
  );
};

export default Configuration;
